module.exports = __webpack_public_path__ + "img/minus.064877a3.svg";